import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";

const KEY = ["billing"] as const;

export function useLedger(limit: number, offset: number) {
  return useQuery({
    queryKey: [...KEY, "ledger", { limit, offset }],
    queryFn: () => api.getLedger(limit, offset),
  });
}

export function useRecharges(limit = 50) {
  return useQuery({
    queryKey: [...KEY, "recharges", { limit }],
    queryFn: () => api.listRecharges(limit),
  });
}

export function useCreateRecharge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createRecharge,
    onSuccess: () => qc.invalidateQueries({ queryKey: [...KEY, "recharges"] }),
  });
}

/** 订单状态轮询: pending 时每 2s 一次; paid / failed 停止; no 为空 (弹窗关闭) 不请求 */
export function useRechargeStatus(no: string | null) {
  return useQuery({
    queryKey: [...KEY, "order", no],
    queryFn: () => api.getRecharge(no!),
    enabled: !!no,
    refetchInterval: (q) => (q.state.data && q.state.data.status !== "pending" ? false : 2000),
    refetchIntervalInBackground: true,
    gcTime: 0,
  });
}

/** 余额变化后刷新流水 / 订单 / 当前用户 (侧边栏余额) */
export function useInvalidateBalance() {
  const qc = useQueryClient();
  return () => {
    void qc.invalidateQueries({ queryKey: KEY });
    void qc.invalidateQueries({ queryKey: ["me"] });
  };
}
